export default "__VITE_ASSET__CSZSITR8__"